<template>
<el-dialog :visible.sync="dialogVisible" top="0" :before-close="closeModal" width="697px">
    <div class="text-center pt-5">
        <AlertBalloon :color="getPrimaryColorHex.four" :secundaryColor="getPrimaryColorHex.two"/>
        <h3 class="c-ndarkthree bold pt-3"> 
            Comentários - {{ ratedCompanyName }}
        </h3>
    </div>
    <!-- //TODO: Fix table-row styling -->
    <div class="mx-5 border-box py-0">
        <div class="div-scroll">
            <div>
                <div v-for="(user, index) in usersCommentsData" :key="user.companyName">
                    <div>
                        <NameInitials name="NONE" size="48"/>
                        <div class="d-flex flex-column">
                            <div class="mb-2">
                                <star-rating
                                    inactive-color="#DFE2EB"
                                    :star-size="20"
                                    :rating="user.score"
                                    :read-only="true"
                                    :show-rating="false"
                                    :increment="1"
                                />
                            </div>
                            <div class="d-flex flex-wrap">
                                <span
                                    v-for="tag in getTagsArray(user)"
                                    class="tags c-ndarkfour bold py-1 px-2 mr-2 mb-2"
                                    :key="tag"
                                    style="font-size: 12px"
                                >
                                    {{ tag.toUpperCase() }}
                                </span>
                            </div>
                            <div v-if="user.notes" class="mt-1 d-flex align-items-center">
                                <BallonQuestion />
                                <span class="c-ndarkfour ml-2 pt-1 medium">{{ user.notes }}</span>
                            </div>
                            <h6 class="mt-2 mb-0 c-nmidone">{{ user.updatedAt | formatDateHour }}</h6>
                        </div>
                    </div>
                    <hr class="hr-users-rating my-4" v-if="usersCommentsData.length !== (index + 1)">
                </div>
            </div>
        </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <button :class="`btn btn-${getPrimaryColor}`" @click="closeModal">
            Fechar
        </button>
    </span>
</el-dialog>
</template>

<script>
// Icons
import AlertBalloon from '@/components/icons/AlertBalloon'
import NameInitials from '@/components/icons/NameInitials'
import BallonQuestion from '@/components/icons/BallonQuestion'

// Libraries
import StarRating from 'vue-star-rating'

export default {
    components: {
        AlertBalloon,
        NameInitials,
        BallonQuestion,
        StarRating
    },
    props: {
        dialogVisible: {
            type: Boolean,
            required: true,
            default: false
        },
        ratedCompanyName: {
            type: String,
            default: 'None'
        },
        usersCommentsData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        getTagsArray(usersCommentsData) {
            if(usersCommentsData.tags) {
                return usersCommentsData.tags.split(', ')
            }

            return []
        },
    },
}
</script>

<style lang="scss">

.div-scroll {
    overflow: auto;
    max-height: 290px;
    min-width: 450px;
    padding: 40px 0;
    > div {
        margin-right: 60px!important;
    }
}

.tags {
    background-color: #F4F7FB;
    border-radius: 26px;
}

.hr-users-rating {
    height: 1px;
}

</style>
